module.exports = __webpack_public_path__ + "img/lxwm.a26a8cbb.jpg";